import React from 'react';
import Card from '../components/card';
import { InfoCopy, InfoLink } from '../components/info-link';
import { DollarTextField } from '../components/MaskedTextField';
import style from '../styles/form';
import { LoanCard } from './card-lenses';

const Info = (props) => (
  <InfoLink title="Child Support / Alimony" {...props}>
    <h6>Child Support</h6>
    <InfoCopy>
      Payment for the support of the children of divorced or separated parents while the children
      are minors or as otherwise legally required.
    </InfoCopy>
    <h6>Alimony</h6>
    <InfoCopy>
      Money that a court orders someone to pay regularly to a former wife or husband after a
      divorce.
    </InfoCopy>
  </InfoLink>
);

const Alimony = ({ model, onChange, ...cardProps }) => (
  <Card
    title="What is your monthly payment for child support or alimony?"
    info={Info}
    {...cardProps}
  >
    <DollarTextField
      name="alimonyPayment"
      value={model.get('alimonyPayment')}
      onChange={onChange.bind(null, 'alimonyPayment')}
      style={style.threeQuarters}
      floatingLabelText="Monthly Payment"
    />
  </Card>
);

Alimony.id = 'Alimony';

Alimony.completed = ({ model }) => model.get('alimonyPayment');

export default LoanCard(Alimony);



// WEBPACK FOOTER //
// ./src/cards/alimony.js